import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

/**
 * What keeps a design from being activated, as one warning icon; the reasons
 * show on hover and to screen readers. Renders nothing when there are none.
 */
@Component({
  selector: 'app-design-issues',
  standalone: true,
  imports: [NgIcon, HlmTooltipImports],
  providers: [provideIcons({ lucideTriangleAlert })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex' },
  template: `
    @if (text(); as text) {
      <span
        class="inline-flex size-6 cursor-help items-center justify-center rounded-full bg-amber-100 text-amber-700"
        role="img"
        tabindex="0"
        [attr.aria-label]="'Noch nicht verwendbar: ' + text"
        [hlmTooltip]="text">
        <ng-icon name="lucideTriangleAlert" size="14" />
      </span>
    }
  `,
})
export class DesignIssuesComponent {
  readonly issues = input<string[] | null | undefined>([]);
  readonly text = computed(() => (this.issues() ?? []).join(' · ') || null);
}
